import {Column, Entity, PrimaryColumn} from "typeorm"
import { bigint } from "../../transofrmers/BigInt";

@Entity({name: "wireless_logic_details"})
export class WirelessLogicDetails {

	@PrimaryColumn()
	iccid!: string;

	@Column({ nullable: true })
	billing_account_number!: string;

	@Column({ nullable: true })
	billing_account_name!: string;

	@Column({ nullable: true })
	active_connection_msisdn!: string;

	@Column({type: 'datetime', nullable: true, default: null})
	active_connection_activation_date!: Date;

	@Column({type: 'datetime', nullable: true, default: null})
	active_connection_cancellation_date!: Date;

	@Column({type: 'datetime', nullable: true, default: null})
	active_connection_billing_start_date!: Date;

	@Column({ nullable: true })
	active_connection_status!: string;

	@Column({ nullable: true })
	active_connection_customer_tariff_id!: number;

	@Column({ nullable: true })
	billing_account_id!: string;

	@Column({ nullable: true })
	active_connection_customer_tariff_name!: string;

	@Column({ nullable: true })
	active_connection_customer_tariff_customer_name!: string;

	@Column({ nullable: true })
	active_connection_customer_tariff_contract_length!: number;

	@Column({ nullable: true })
	active_connection_customer_tariff_rental!: number;

	@Column({ nullable: true })
	active_connection_customer_tariff_gprs_inc!: number;

	@Column({ nullable: true })
	active_connection_customer_tariff_gprs_inc_label!: string;

	@Column({ nullable: true })
	active_connection_customer_tariff_gprs_inc_description!: string;

	@Column({ nullable: true })
	active_connection_ip_address!: string;

	@Column({ nullable: true })
	mno_account_id!: number;

	@Column({ nullable: true })
	mno_account_name!: string;

	@Column({ nullable: true })
	mno_account_mno_id!: number;

	@Column({ nullable: true })
	mno_account_mno_name!: string;
	
	@Column({ nullable: true })
	custom_field1!: string;
	
	@Column({ nullable: true })
	custom_field2!: string;
	
	@Column({ nullable: true })
	custom_field3!: string;
	
	@Column({ nullable: true })
	custom_field4!: string;

	@Column({ nullable: true })
	custom_field5!: string;

	@Column({ nullable: true })
	custom_label!: string;

	@Column({type: 'datetime', nullable: true, default: null})
	dispatch_date!: Date;

	@Column({default:false})
	ignore_notifications!: boolean;

	@Column({type: 'datetime', nullable: true, default: null})
	internal_last_seen!: Date;

	@Column({ nullable: true })
	device_type!: string;

	@Column({ nullable: true, type: "bigint", transformer:bigint })
	tariff_value!: number;

	@Column({ type: "bigint", default:0, transformer:bigint })
	current_data_up!: number;

	@Column({ type: "bigint", default:0, transformer:bigint })
	current_data_down!: number;

	@Column({ type: "bigint", default:0, transformer:bigint })
	current_data_total!: number;

	@Column({ type: "bigint", default:0, transformer:bigint })
	current_voice_up!: number;

	@Column({ type: "bigint", default:0, transformer:bigint })
	current_voice_down!: number;

	@Column({ type: "bigint", default:0, transformer:bigint })
	current_voice_total!: number;

	@Column({ type: "bigint", default:0, transformer:bigint })
	current_sms_up!: number;

	@Column({ type: "bigint", default:0, transformer:bigint })
	current_sms_down!: number;

	@Column({ type: "bigint", default:0, transformer:bigint })
	current_sms_total!: number;

	@Column({ type: "datetime", nullable: true, default: null })
	last_seen_detail!: Date;

	@Column({default:null, nullable: true})
	linked_sim_iccid!: string;
} 